import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';
import { Motif } from './Ornaments';

const EDITORIAL_EASE = [0.22, 1, 0.36, 1];
const MARK_HIDDEN = { opacity: 0, y: 18 };
const MARK_SHOWN = { opacity: 1, y: 0 };
const MARK_TRANSITION = { duration: 0.9, ease: EDITORIAL_EASE };
const ART_HIDDEN = { opacity: 0, rotate: 2 };
const ART_SHOWN = { opacity: 1, rotate: 0 };
const ART_TRANSITION = { duration: 1.1, delay: 0.15 };
const LINE_HIDDEN = { y: '110%' };
const LINE_SHOWN = { y: 0 };

export const Hero = () => {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start start', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 26]);
  return <section ref={ref} className="hero page-inset" data-testid="hero" aria-labelledby="hero-name">
    <div className="hero-identity">
      <motion.div className="identity-mark" data-testid="hero-identity-mark" initial={reduced ? false : MARK_HIDDEN} animate={MARK_SHOWN} transition={MARK_TRANSITION}>
        <span className="devanagari" lang="hi" aria-label="Pra" data-testid="hero-monogram">प्र</span><Motif testId="hero-blue-motif" />
      </motion.div>
      <h1 id="hero-name" data-testid="hero-name">Pranjali Saxena</h1>
      <p className="hero-role" data-testid="hero-role">COMMUNICATION DESIGNER<br />BRANDING · VISUAL COMMUNICATION · STORYTELLING</p>
      <p className="hero-location" data-testid="hero-location">Bengaluru, India <span>↗</span></p>
    </div>
    <motion.div className="hero-art" style={{ y: reduced ? 0 : y }} initial={reduced ? false : ART_HIDDEN} animate={ART_SHOWN} transition={ART_TRANSITION}>
      <img className="hero-chai" src="/images/refinements/chai.webp" width="357" height="465" alt="An ornamental Indian chai glass" data-testid="hero-chai" />
      <img className="hero-stamp" src="/images/refinements/heritage-stamp.webp" width="784" height="994" alt="Amroha heritage architecture on an Indian postage stamp" data-testid="hero-stamp" />
    </motion.div>
    <div className="hero-manifesto">
      <h2 className="hero-headline" data-testid="hero-headline">
        {['BRANDS, STORIES &', 'CHAI-FUELLED IDEAS.'].map((line, i) => <span className="line-mask" key={line}><motion.span initial={reduced ? false : LINE_HIDDEN} animate={LINE_SHOWN} transition={{ duration: 0.9, delay: 0.22 + i * 0.13, ease: EDITORIAL_EASE }}>{line}</motion.span></span>)}
      </h2>
      <p className="personality-line" data-testid="hero-personality">Currently collecting ideas, references & chai.</p>
    </div>
    <div className="hero-about">
      <h2 className="hero-about-title" data-testid="hero-about-title">ABOUT</h2>
      <p data-testid="hero-description">A communication designer drawn to the space between culture, craft and contemporary design. I like turning ideas into visual stories that feel thoughtful, useful and grounded in context.</p>
      <p className="hero-footnote" data-testid="hero-footnote">I’m interested in the stories behind things, where they come from, why they matter, and how design can make them feel relevant again.</p>
      <Link className="text-link" data-testid="hero-about-link" to="/about">MORE ABOUT ME <span>→</span></Link>
    </div>
    <span className="hero-edition eyebrow" data-testid="hero-edition">A WORK IN PROGRESS. ALWAYS.</span>
  </section>;
};